/* eslint-disable @typescript-eslint/no-explicit-any */
import { Megaphone } from 'lucide-react';
import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import apiClient from '../api/client';
import { AdPopUp } from './ads/AdPopUp';

export interface Ad{
  id?: string;
  title?: string;
  image?: string;
  isActive?: boolean;
  url?: string;
  description?: string;
}

// const ads = [
//   { id: 1, title: 'Local Coffee Shop', image: 'https://images.unsplash.com/photo-1509042239860-f550ce710b93?q=80&w=1000&auto=format&fit=crop', link: '#' },
//   { id: 2, title: 'Tech Conference 2025', image: 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?q=80&w=1000&auto=format&fit=crop', link: '#' },
// ];

export default function AdvertisementSection() {
  const [ads, setAds] = useState<Ad[] | []>([]);
  const [loading, setLoading] = useState(true);

  const [selectedAd, setSelectedAd] = useState<Ad | null>(null);
  const [open, setOpen] = useState(false);


  const fetchAds=async()=>{
    setLoading(true)
    try{
      const {data} = await apiClient.get(`/admin/ads/active`)

      if(data?.success){
        setAds(data?.ads)
      }
    }
    catch(error: any){
      toast.error(error?.response?.data?.message || error?.message)
    }
    finally{
      setLoading(false)
    }
  }

  useEffect(()=>{fetchAds()}, [])

  return (
    <section className="py-16 px-4 bg-[#042033] bg-linear-to-b from-black to-[#042033]">
      <div className="max-w-6xl mx-auto">
        {
          !loading && ads.length > 0 &&
          <div className="flex items-center gap-2 mb-8 opacity-50">
            <Megaphone className="w-4 h-4" />
            <span className="text-sm font-medium uppercase tracking-widest">Sponsored Content</span>
          </div>
        }
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {ads?.map((ad) => (
            // <div 
            //   key={ad?.id} 
            //   className="group relative aspect-video rounded-2xl overflow-hidden block border border-white/10 hover:border-cyan-500/50 transition-all"
            //   onClick={()=>{
            //     setSelectedAd(ad);
            //     setOpen(true)
            //   }}
            // >
            //   <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors z-10" />
            //   <img 
            //     src={ad?.image} 
            //     alt={ad?.title} 
            //     className="w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-700"
            //   />
            //   <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent z-20">
            //     <span className="inline-block px-2 py-1 mb-2 text-[10px] font-bold text-white bg-white/20 rounded uppercase tracking-wider backdrop-blur-sm">
            //       Ad
            //     </span>
            //     <h3 className="text-xl font-bold text-white group-hover:text-cyan-400 transition-colors">{ad?.title}</h3>
            //   </div>
            // </div>

            <div 
              key={ad?.id} 
              className="group car relative aspect-video rounded-2xl overflow-hidden block border border-white/10 hover:border-cyan-500/50 transition-all"
              onClick={()=>{
                setSelectedAd(ad);
                setOpen(true)
              }}
            >
              {/* soft blurred background */}
              <img
                src={ad?.image}
                alt=""
                className="absolute inset-0 w-full h-full object-cover blur-md scale-105 opacity-30"
              />

              {/* dark hover overlay */}
              <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors z-10" />

              {/* main image (no crop) */}
              <img 
                src={ad?.image} 
                alt={ad?.title} 
                className="relative z-0 w-full h-full object-contain transform group-hover:scale-105 transition-transform duration-700"
              />

              {/* bottom gradient content */}
              <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent z-20">
                <span className="inline-block px-2 py-1 mb-2 text-[10px] font-bold text-white bg-white/20 rounded uppercase tracking-wider backdrop-blur-sm">
                  Ad
                </span>
                <h3 className="text-xl font-bold text-white group-hover:text-cyan-400 transition-colors">
                  {ad?.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      <AdPopUp
        ad={selectedAd}
        open={open}
        onClose={() => setOpen(false)}
       />
    </section>
  );
}
